import { assertNever } from '@kofno/piper';
import { dataLayerUpdate } from '../../../../../components/Tooling/GoogleTagManagerTooling/Loader';
import { ExperienceResource } from '../../../Common/Experience/Types';
import ExperiencesStore from './ExperiencesStore';

// Tells GTM that a learner clicked a Discovery Portal search result. GTM used
// to add these click listeners itself in a Custom HTML tag, which needs
// 'unsafe-inline' in the CSP. position is 1-based. The event name differs from
// the old tag's 'searchResultClick' so that a click is not counted twice while
// both are live.
export const searchResultClick =
  (store: ExperiencesStore, position: number, experienceResource: ExperienceResource) =>
  (): void => {
    const { state } = store;
    switch (state.kind) {
      case 'experiences': {
        state.search.do(() => {
          dataLayerUpdate({
            event: 'discovery-portal-search-result-click',
            searchResultPosition: position,
            searchResultTitle: experienceResource.payload.title.text.slice(0, 100),
          });
        });
        break;
      }
      case 'waiting':
      case 'loading':
      case 'searching':
      case 'product-collections':
      case 'product-collections-and-experiences':
      case 'error': {
        break;
      }
      default: {
        assertNever(state);
      }
    }
  };
